import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from 'lodash';
import classNames from 'classnames';
import Button from "../../components/Button/Button";
import FormActions from "../../components/FormActions/FormActions";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";

const requiredChecks = {
	studentEntry : <span>A completed <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F413bfbf3-3d11-44bc-b1de-23b362c44261_180705_student+entry+form+%281%29.pdf" target="_blank" rel="noopener noreferrer">Student Entry</a> form for each member of your filmmaking team (signed by parent/guardian)</span>,
	talentRelase : <span>A signed <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F1d80acd6-7fd7-4f80-bc89-d4ef85f3b0ef_180705_talent+release+form+u16.pdf" target="_blank" rel="noopener noreferrer">Talent Release</a> form for any other people that appear in your video</span>,
	videoFormat : <span>Your video file in one of the following formats (MP4, MOV, MPEG4, AVI, WMV or WebM)</span>,
	competitionRequirements : <span>We confirm that we have met all the requirements for the competition and only copyright free content has been used</span>,
	originalWork : <span>Our video entry is our original work created in 2018 and meets the requirements for the competition</span>
}

class Stage1 extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			inputs: {}
		}
		_.each(requiredChecks, (label, name) => {
			let inputs = this.state.inputs;
			inputs[name] = false;
			this.setState({inputs:inputs});
		});	
		
		this.handleInputEvent = this.handleInputEvent.bind(this);
		this.checkboxClasses = this.checkboxClasses.bind(this);

	}
	
	handleInputEvent = (e, key) => {
		let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
		// console.log('setting to ',key, value, e.target.checked);
		this.setState({
			inputs: {
				...this.state.inputs,
				[key]: value
			}
		});
		// console.log(this.state.inputs);
	};
	
	isValid = () => {
		let isValid = true;
		if(!this.state.inputs) return false;
		_.each(this.state.inputs, (input, i) => {
			if(!input) isValid = false;
		})
		return isValid;
	}
	
	checkboxClasses = (input) => {
		return classNames({
			'checkbox': true,
			"-checked": this.state.inputs[input],
		});
	}
	
	renderCheckboxes = () => {

		let checkboxes = [];
		_.each(requiredChecks, (label, name) => {
			checkboxes.push(<div className={this.checkboxClasses(name)} key={name}>
			<label htmlFor={name} >
			<input type="checkbox" name={name} id={name} checked={this.state.inputs[name]} onChange={e => this.handleInputEvent(e, name)} />
			{label}</label>
			</div>)
		});
		return checkboxes;
	}
	
	getStarted = async () => {
		const id = await this.props.methods.newEntry(this.props.competitionId);
		this.props.history.push(`/competition/${this.props.slug}/enter/${id}`);
	};
	
	render() {

		if(!this.props.terms) return null;

		return (
			<div className="checklist-questions">

			<RichText content={this.props.terms.stage_1} />

			<div>
				{this.renderCheckboxes()}
			</div>
			
			<FormActions
			left={<div />}
			right={
				<div>
				<Button onClick={this.getStarted} disabled={!this.isValid()} type="secondary">Let's Go</Button>
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage1)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage1.js